import React, { useRef } from "react";
import TheGreatSage from "../coursespage/TheGreatSage";
import AshramaFaculty from "../coursespage/AshramaFaculty";
import AshramaBenefits from "../coursespage/AshramaBenefits";
import FinestKnowledge from "../coursespage/FinestKnowledge";
import ContactUs from "../common/ContactUs";
import SahajYogaCard from "../common/SahajYogaCard";
import Footer from "../common/Footer";
import HeaderOnly from "../homepage/HeaderOnly";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = document.getElementById(location.hash.substr(1));
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  const myRef = useRef(null);
  const scrollToRef = () => {
    if (myRef.current) {
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <HeaderOnly />
      <ContactUs ContactUsREf={myRef}/>
      <SahajYogaCard click={scrollToRef} />
      <Footer />
    </>
  );
};

export default Contact;
